import { client } from './api';

class LotTypeService {
  getLotTypes = async () => {
    const response = await client.get('lotType');

    return response;
  };
}

export default new LotTypeService();
